import React, { useState, useCallback, useEffect } from 'react';
import { translate } from 'base/shared/Localization';
import { Flex, Text, Icon, BADI_COLORS, Heading } from '@badi/badi-components';
import { getPublicAsset } from 'base/shared/Utils';
import { getPlaceType } from 'datamodel/SearchFilters/utils';
import { getSearchDefaultValues, getLastSearchLocation } from '../search-bar-home/utils';
import { DATE_FORMAT } from '../search-bar-home/constants';
import { SEARCH_TYPES } from '../../../../constants';
import { getHouseRules } from 'datamodel/SearchFilters/utils';
import {
  SearchBarLayer,
  SearchBarWrap,
  SearchButton,
  SearchFields,
  StyledFlex,
} from './styled-components';
import LocationSelectorAutosuggest from './components/location-selector-autosuggest';
import DateSelector from './components/date-selector';
import LengthStaySelector from './components/length-stay-selector';
import WhoIsMovingSelector from './components/who-is-moving-selector';

const SimpleSearchBar = ({
  stayOptions,
  setParams,
  searchType,
  setSearchType,
  title,
  isBadiPlus = false,
}) => {
  const { moveInDate, lengthStay, stayOption } = getSearchDefaultValues(stayOptions);
  const [location, setLocation] = useState(null);
  const [fromDate, setMoveIn] = useState(moveInDate);
  const [stayOptionsSelected, setStayOptions] = useState(stayOption);
  const [whoIsMoving, setWhoIsMoving] = useState(1); // Default to "just me"
  const [showPopover, setShowPopover] = useState(false);

  const handleLocationChange = useCallback((suggest) => {
    const { label: text, meta } = suggest;
    const city = meta ? meta.city : '';
    setShowPopover(false);
    setLocation({ ...suggest, city, text });
  }, []);

  const handleMoveInDateChange = useCallback((moveInSelected) => {
    const date = moveInSelected ? moveInSelected.format(DATE_FORMAT) : null;
    setMoveIn(date);
  }, []);

  const handleLengthStayChange = useCallback((length) => {
    setStayOptions(length);
  }, []);

  const handleWhoIsMovingChange = useCallback((value) => {
    setWhoIsMoving(value);
  }, []);

  const handleSearch = () => {
    if (!location) {
      setShowPopover(true);
    } else {
      const placeTypes = getPlaceType();
      const placeTypeSelectedId = searchType === SEARCH_TYPES.ENTIRE ? 2 : 1;

      const index = placeTypes.findIndex(({ id }) => id === placeTypeSelectedId);
      placeTypes[index] = { ...placeTypes[index], selected: true };

      const searchParams = {
        ...location,
        fromDate,
        now: false,
        stayOptions: stayOptionsSelected,
        placeTypes,
      };

      if (isBadiPlus) {
        searchParams.marketplaceSegmentsFilter = {
          badiRooms: true,
          badiCommunity: false,
        };
        searchParams.whoIsMoving = whoIsMoving;

        // Add couples amenity when "another person and me" is selected (value 2)
        if (whoIsMoving === 2) {
          const houseRules = getHouseRules();
          const couplesRule = houseRules.find((rule) => rule.id === 13);
          if (couplesRule) {
            searchParams.houseRules = [
              {
                ...couplesRule,
                selected: true,
              },
            ];
          }
        }
      }

      setParams(searchParams);
    }
  };

  useEffect(() => {
    const suggest = getLastSearchLocation();
    if (!location && suggest) {
      handleLocationChange(suggest);
    }
  }, []);

  const handleSearchRoomClick = () => {
    setSearchType(SEARCH_TYPES.ROOM);
  };

  const handleSearchApartmentClick = () => {
    setSearchType(SEARCH_TYPES.ENTIRE);
  };

  return (
    <SearchBarLayer>
      <Flex alignItems="center" as={StyledFlex} direction="column" gutter={2} justify="center">
        {/* <Heading color={BADI_COLORS.NEUTRAL.NEUTRAL_00} align="center">
          {title}
        </Heading> */}
        {/* <NavigationSearch wide={true}>
          <Flex alignItems="center" as={Flex} justify="center">
            <SearchMenuButton
              onClick={handleSearchRoomClick}
              selected={searchType === SEARCH_TYPES.ROOM}
            >
              <Text body="16-Regular" color={BADI_COLORS.NEUTRAL.NEUTRAL_00}>
                {translate('topbar.element.search.room')}
              </Text>
            </SearchMenuButton>
            <SearchMenuButton
              onClick={handleSearchApartmentClick}
              selected={searchType === SEARCH_TYPES.ENTIRE}
            >
              <Text body="16-Regular" color={BADI_COLORS.NEUTRAL.NEUTRAL_00}>
                {translate('topbar.element.search.entire')}
              </Text>
            </SearchMenuButton>
          </Flex>
        </NavigationSearch> */}
        <SearchBarWrap>
          <SearchFields>
            <Flex alignItems="center" gutter={1}>
              <LocationSelectorAutosuggest
                grow={1}
                handleLocationChange={handleLocationChange}
                initialValue={location ? location.text : ''}
                showPopover={showPopover}
              />
              {isBadiPlus ? (
                <WhoIsMovingSelector
                  grow={1}
                  id="who-is-moving-selector"
                  initialValue={whoIsMoving}
                  onChange={handleWhoIsMovingChange}
                />
              ) : null}
              <DateSelector
                fromDate={fromDate}
                grow={1}
                handleMoveInDateChange={handleMoveInDateChange}
              />
              {!isBadiPlus ? (
                <LengthStaySelector
                  grow={1}
                  id="length-stay-selector"
                  initialStay={lengthStay}
                  onChange={handleLengthStayChange}
                  stayOptions={stayOptions}
                />
              ) : null}
            </Flex>
          </SearchFields>
          <SearchButton data-qa="search-bar-availability-button" onClick={handleSearch}>
            <Icon
              alt="search"
              iconMaxHeight={42}
              iconMaxWidth={42}
              src={getPublicAsset(
                isBadiPlus ? 'icons/home/search_btn_gradient.svg' : 'icons/home/search_btn.svg'
              )}
            />
          </SearchButton>
        </SearchBarWrap>
      </Flex>
    </SearchBarLayer>
  );
};

export default SimpleSearchBar;
